__turbopack_context__.v({
  "prohibitedNoticeText": "ProhibitedNotice-module__0mm4La__prohibitedNoticeText",
});
